
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gQ9xKgrb2bTQqIxeCC98oC_45wM4kOrABZsTfE_O8hlIEwMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexiDZLwSe9buXIjgw4wXm4YGplSaPUNXnLwudT7klqxuoMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchRAh2W7kO17rCPd3IKIm7wZDvUtsllNMNWEzOtTFBrDoMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index60aNxk7r5yMsWObhQrq5M5EZJI0a3uDHbNghO85rkeMMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Gc2Yh2MeNqTnmVJEa9PrOW5ZRH8pp3bQaA7SXDB0KQAMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index6qMsZB3WQ4k7EqQWDAkYu8d24OcdQjrjEbcyr_uAxukMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93efhN9KfQLYbbSTA5WBwVGnLMReLCuzis0SHBl3qmK5cMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWi27JIKbeXh_455S_Ccrkyw0eKCgc30jpfLIpdShmwWg4Meta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93BJ2FeFLfu7izD_4559DlX71iyrvVAebGmK9r7OWRszsjUMeta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexk7eDxl7698_mehHLsAtmXhWjfqASWy_45waT7LvXxSce8Meta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index5i_i2g0YWQoVQkSpZ8vBuz_45ortFEKAQXhzeSgCu0Ua8Meta } from "/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index6qMsZB3WQ4k7EqQWDAkYu8d24OcdQjrjEbcyr_uAxukMeta || {},
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWi27JIKbeXh_455S_Ccrkyw0eKCgc30jpfLIpdShmwWg4Meta || {},
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexk7eDxl7698_mehHLsAtmXhWjfqASWy_45waT7LvXxSce8Meta || {},
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index5i_i2g0YWQoVQkSpZ8vBuz_45ortFEKAQXhzeSgCu0Ua8Meta || {},
    component: () => import("/codebuild/output/src1026439801/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]